import React from 'react';
import { ButtonV2, ButtonV2Props } from '@withjoy/joykit';
import { Category } from '@graphql/generated';
import { pxToRem } from '@withjoy/joykit/theme';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useScaleGuestSiteFontSize } from '@apps/guest/components/GuestSiteTypographyOverride/hooks/useScaleGuestSiteFontSize';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { button2ToButtonsOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';

interface CTAButtonProps extends ButtonV2Props {
  ctaTitle: string;
}

export const CTAButton: React.FC<CTAButtonProps> = ({ ctaTitle, variant = 'solid', ...buttonProps }) => {
  const [fontPackExperimentEnabled] = useIsFeatureEnabled('fontPackExperiment');
  const { scaleFontSize } = useScaleGuestSiteFontSize();

  return (
    <GuestSiteTypographyOverride
      override={button2ToButtonsOverride}
      defaultFontFamily="Inter UI"
    >
      <ButtonV2
        intent="neutral"
        shape="rounded"
        fontWeight={600}
        fontSize={scaleFontSize(pxToRem(16), Category.BUTTONS)}
        {...(!fontPackExperimentEnabled && { fontFamily: 'Inter UI' })}
        variant={variant}
        {...buttonProps}
      >
        {ctaTitle}
      </ButtonV2>
    </GuestSiteTypographyOverride>
  );
};
